/**
 * NumberSeriesSettings Component
 *
 * Number series tab content: how each agenda spells the numbers it issues.
 */
import { Paper } from '@insio/ui-toolkit';
import { useNumberSeriesSettings } from '../../hooks/use-number-series-settings';
import { EditNumberSeriesModal, NumberSeriesTable } from './number-series';

export function NumberSeriesSettings() {
  const {
    series,
    showSkeleton,
    loadError,
    editing,
    draft,
    configIssues,
    livePreview,
    canSave,
    isSaving,
    saveError,
    openEditor,
    closeEditor,
    updateDraft,
    handleSave
  } = useNumberSeriesSettings();

  return (
    <div className='space-y-lg'>
      <Paper showDivider={false} padding='none'>
        <NumberSeriesTable
          rows={series}
          loading={showSkeleton}
          error={loadError}
          onEdit={openEditor}
        />
      </Paper>

      {editing && draft && (
        <EditNumberSeriesModal
          series={editing}
          draft={draft}
          issues={configIssues}
          preview={livePreview}
          canSave={canSave}
          isSaving={isSaving}
          error={saveError}
          onChange={updateDraft}
          onSubmit={handleSave}
          onClose={closeEditor}
        />
      )}
    </div>
  );
}
